export default "__VITE_ASSET__CeNzJfhf__"